import React from 'react';
import ApexChart from 'react-apexcharts';
import { Status } from '../../util';

type Props = { status: Status; colors: string[]; loading: boolean };

const PolarChartCard = ({ status, colors, loading }: Props) => {
  return (
    <ApexChart
      type={'polarArea'}
      series={
        loading
          ? [5]
          : (status?.cards?.filter(x => x.type !== 'total').map(x => x.count) ??
            [])
      }
      width={400}
      options={{
        dataLabels: { enabled: true },
        chart: {
          offsetX: 0,
          animations: {
            enabled: false,
          },
        },
        labels: loading
          ? ['LOADING...']
          : status.cards
              .filter(x => x.type !== 'total')
              .map(x => x.type.toUpperCase()),
        legend: {
          width: 150,
          showForZeroSeries: true,
          showForNullSeries: true,
          showForSingleSeries: true,
          formatter: (val: string, opts: any) => {
            return `${val} ${
              loading ? '' : `(${opts?.w?.globals?.series?.[opts.seriesIndex]})`
            }`;
          },
          fontFamily: 'inherit',
          fontSize: '14px',
          show: true,
          offsetY: -16,
          markers: {
            offsetY: 3,
            offsetX: -8,
            size: 8,
          },
          itemMargin: { vertical: 4 },
        },
        stroke: { width: 0 },
        fill: { opacity: 1 },
        yaxis: { show: false },
        colors: loading ? ['#f8f8f8'] : colors,
        plotOptions: {
          polarArea: {
            rings: {
              strokeWidth: 1,
              strokeColor: '#f8f8f8',
            },
            spokes: {
              strokeWidth: 2,
            },
          },
        },
      }}
    />
  );
};

export default PolarChartCard;
